export const demoConstants = {
    VIEW_DEMO_GUEST_ACCOUNT_REQUEST: 'VIEW_DEMO_GUEST_ACCOUNT_REQUEST',
    VIEW_DEMO_GUEST_ACCOUNT_SUCCESS: 'VIEW_DEMO_GUEST_ACCOUNT_SUCCESS',
    VIEW_DEMO_GUEST_ACCOUNT_FAILURE: 'VIEW_DEMO_GUEST_ACCOUNT_FAILURE',
};
